import React from 'react';
import DiscountFlagImage from '../DiscountFlagImage';

const getBoletoInput = (props, i) => {
  return (
    <React.Fragment>
      <input
        type="radio"
        name="methodPayment"
        onChange={() => props.selectPaymentMethod(i)}
        checked={!!props.paymentMethods[i].selected}
        id={props.paymentMethods[i].class}
      />

      <DiscountFlagImage
        paymentMethod={props.paymentMethods[i]}
        content={
          <label htmlFor={props.paymentMethods[i].class}>
            <h4>{props.paymentMethods[i].name}</h4>
            <span>Pague seu seguro viagem com o boleto e ganhe desconto</span>
          </label>
        }
      />
    </React.Fragment>
  );
};

export default getBoletoInput;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/desktop/inputs/getBoletoInput.jsx